// 数据操作
import { rlPoint } from "../class/rlPoint";
// 数据操作部分内容
import store from "@/store/index";

// 获取所有选中的图形对象
export const get_select_array = () => {
  // 获取图形对象
  let entityIds = rlAppObj.rlMxDrawObject.getMxCurrentSelect();
  let entityObj = entityIds.map((id) =>
    rlAppObj.rlMxDrawObject.getMxEntity(id)
  );
  return entityObj;
};

// 通过图形对象id返回对象
export const get_entity_by_id = (id) => {
  if (id) return rlAppObj.rlMxDrawObject.getMxEntity(id);
  else return null;
};
export const del_all_entity_group = () => {
  del_entity_group("rlPointGroup");
  del_entity_group("rlLineAxisGroup");
  del_entity_group("rlLineGridGroup");
  del_entity_group("rlBeamGroup");
  del_entity_group("rlColumnGroup");
  del_entity_group("rlWallGroup");
  del_entity_group("rlSlabGroup");

  del_entity_group("rlLineGroup");
  del_entity_group("rlCircleGroup");
  del_entity_group("rlTextGroup");
};

// 删除图形对象组
export const del_entity_group = (groupName) => {
  let rlPointGroup = rlAppObj.rlMxDatabase.getGroup(groupName)?.getAll();
  if (!rlPointGroup) return;
  del_entity(rlPointGroup);
  rlAppObj.rlMxDatabase.getGroup(groupName)?.clear();
};

// 删除图形对象
export const del_entity = (entity) => {
  if (Array.isArray(entity)) {
    entity.forEach((item) => {
      item?.erase();
    });
  } else {
    entity?.erase();
  }
  rlAppObj._rlMx.MxFun.updateDisplay();
  return true;
};

//构造一些假数据
export const testNewpoint = () => {
  return;
  const ptTest = new rlPoint();
  ptTest.setPoints(Math.random(), Math.random(), 0);
  let data = rlAppObj.rlMxDrawObject.addMxEntity(rlObject);
  rlAppObj.rlMxDrawObject.updateDisplay();
  return data;
};

export const testDeleteData = (obj) => {
  obj.erase();
};

export const testModifyData = (obj) => {
  obj.setPoints(Math.random(), Math.random(), 0);
  return obj;
};

export const clear_entiy_all = () => {
  return rlAppObj.rlMxDrawObject.eraseAllMxEntity();
};

// 删除所有的图形对象数据
export const del_entity_all = () => {
  return store.state.cadModules.deleteEntityIDs;
};

// 获取所有新增的图形对象
export const get_add_array = () => {
  let allMxEntity = rlAppObj.rlMxDrawObject.getAllMxEntity();
  const add_data = allMxEntity.filter((item) => !item.ID);
  let outData = [];
  add_data.forEach((element) => {
    if (
      element.classTypeName != "rlText" &&
      element.classTypeName != "rlLine" &&
      element.classTypeName != "rlEntity" &&
      element.classTypeName != "rlCircle"
    )
      outData.push(element.getDataBase());
  });
  return outData;
};

// 获取所有更新后的图形对象数据
export const get_updata_array = () => {
  let allMxEntity = rlAppObj.rlMxDrawObject.getAllMxEntity();
  const allMxEntity_data = allMxEntity.filter(
    (item) => item.ID && item.statusType == 2
  );
  let outData = [];
  allMxEntity_data.forEach((element) => {
    if (element.ID) {
      outData.push(element.getDataBase());
    }
  });

  return outData;
};

export const updata_entity_Status = () => {
  let allMxEntity = rlAppObj.rlMxDrawObject.getAllMxEntity();
  allMxEntity.forEach((tmpEnt) => {
    if (tmpEnt) {
      tmpEnt.statusType = 1;
    }
  });
  rlAppObj.rlMxDrawObject.updateDisplay();
};

//更新构件的id
export const updata_entity_ID = (data) => {
  let allMxEntity = rlAppObj.rlMxDrawObject.getAllMxEntity();
  Object.keys(data).forEach((itKey) => {
    let tmpEntArray = allMxEntity.filter((item) => itKey == item.guid());
    tmpEntArray.forEach((tmpEnt) => {
      if (tmpEnt) {
        tmpEnt.ID = data[itKey];
        tmpEnt.statusType = 0; //重置状态
      }
    });
  });
  rlAppObj.rlMxDrawObject.updateDisplay();
};

// 获取构件的显隐数据
export const get_structural_data = () => {
  let beamData = store.state.rlEntData.totalEntityData["rlBeamSeg"];
  let isSketch = store.state.globalData.isSketch;
  let mainBeamData = [];
  let subBeamData = [];
  let ringBeamData = [];
  beamData.forEach((item) => {
    if (item.m_sectParamData.IsRingBeamSeg) {
      ringBeamData.push(item);
    }
    //1.6.1版本再发
    else if (item.Attribute == 1) {
      mainBeamData.push(item);
    } else {
      subBeamData.push(item);
    }
  });

  let colsegData = store.state.rlEntData.totalEntityData["rlColSeg"];
  let mainColData = [];
  let constructionColData = [];
  colsegData.forEach((item) => {
    if (item.Attribute == 1) {
      mainColData.push(item);
    } else {
      constructionColData.push(item);
    }
  });

  return {
    jointData: isSketch
      ? store.state.rlEntData.totalEntityData["rlJointC"]
      : store.state.rlEntData.totalEntityData["rlJoint"], //  rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.getAll() || [],
    axisData: store.state.rlEntData.totalEntityData["rlAxis"], // rlAppObj.rlMxDatabase.getGroup("rlLineAxisGroup")?.getAll() || [],
    gridData: isSketch
      ? store.state.rlEntData.totalEntityData["rlGridC"]
      : store.state.rlEntData.totalEntityData["rlGrid"], // rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.getAll() || [],
    beamsegData: mainBeamData, // store.state.rlEntData.totalEntityData["rlBeamSeg"], // rlAppObj.rlMxDatabase.getGroup("rlBeamGroup")?.getAll() || [],
    colsegData: mainColData, //rlAppObj.rlMxDatabase.getGroup("rlColumnGroup")?.getAll() || [],
    constructionColData: constructionColData,
    wallsegData: store.state.rlEntData.totalEntityData["rlWallSeg"], //rlAppObj.rlMxDatabase.getGroup("rlWallGroup")?.getAll() || [],
    slabData: [
      ...store.state.rlEntData.totalEntityData["rlSlab"],
      ...store.state.rlEntData.totalEntityData["rlSlabHole"],
    ], //rlAppObj.rlMxDatabase.getGroup("rlSlabGroup")?.getAll() || [],
    // ringBeamData: store.state.rlEntData.totalEntityData["rlRingBeamSeg"], //rlAppObj.rlMxDatabase.getGroup("rlRingBeamGroup")?.getAll() || [], // 圈梁
    ringBeamData: ringBeamData,
    subBeamData: subBeamData, // store.state.rlEntData.totalEntityData["rlSubBeam"], //rlAppObj.rlMxDatabase.getGroup("rlSubBeamGroup")?.getAll() || [], // 次梁
    wallHoleData: store.state.rlEntData.totalEntityData["rlWallHole"], //rlAppObj.rlMxDatabase.getGroup("rlWallHoleGroup")?.getAll() || [], // 墙洞
    modelNoData: store.state.rlEntData.totalEntityData["rlModelNo"], //rlAppObj.rlMxDatabase.getGroup("rlModelGroup")?.getAll() || [], // 构件号文字
    textAppData: store.state.rlEntData.totalEntityData["rlText"], //rlAppObj.rlMxDatabase.getGroup("rlTextGroup")?.getAll() || [], // 文字
    cantiSlabData: store.state.rlEntData.totalEntityData["rlCantiSlab"], //rlAppObj.rlMxDatabase.getGroup("rlCantiSlabGroup")?.getAll() || [], // 楼梯
    partitionWallSegData:
      store.state.rlEntData.totalEntityData["rlPartitionWallSeg"], // 隔墙
    doorsWindowsData: store.state.rlEntData.totalEntityData["rlDoorsWindows"], // 门窗
    useData: store.state.rlEntData.totalEntityData["rlUse"], // 用途
  };
};
